import React from 'react';

const SizeDetailFieldSet = (props) => {
    if (props.hidden)
        return '';

    return (
        <div>
            <div className="input-group rounded-0">
                <div className="rounded-0 input-group-prepend" style={{width: 15 + '%'}}>
                    <span className="input-group-text rounded-0 bg-white border-0 text-left pl-0">FY{props.fy}</span>
                </div>
                <div className="input-group-prepend rounded-0">
                    <span className="input-group-text rounded-0">Total</span>
                </div>
                <input
                    className="form-control rounded-0 text-right"
                    type="text"
                    name={"size-" + props.fy + "-total"}
                    value={props.totalSize ? props.totalSize : ''}
                    disabled={props.disabled}
                    fy={props.fy}
                    onChange={props.onInputChange} 
                    autoComplete="off" />
                <div className="input-group-prepend rounded-0">
                    <span className="input-group-text rounded-0">Common</span>
                </div>
                <input
                    className="form-control rounded-0 text-right"
                    type="text"
                    name={"size-" + props.fy + "-common"}
                    value={props.commonSize ? props.commonSize : ''}
                    disabled={props.disabled}
                    fy={props.fy}
                    onChange={props.onInputChange}
                    autoComplete="off" />
            </div>
        </div>
    );
}

export default SizeDetailFieldSet;
